<template>
  <div ref="menus" class="menus card">
    <div :class="['menu', { sel: sel == i }]" @click="clicked(i, $event)" v-for="({ label, icon, key, color }, i) in menus" :key="i" :data-key="key" :data-i="i">
      <div class="menu-title">
        <span class="menu-icon"><b-icon :variant="color" scale="1.4" :icon="icon" class="icon" /></span>
        <span class="menu-label">{{ $t(label) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['menus'],
  data: () => ({ sel: 0 }),
  watch: { '$parent.$parent.dirId': 'watchDir' },
  methods: {
    watchDir(dir) {
      if (dir) this.sel = -1;
    },
    clicked(idx, evt) {
      const oldEl = this.$refs.menus.querySelector('.menus .sel');
      this.selected(idx);
      this.$emit('clicked', this.menus[idx]);
    },
    selected(idx) {
      this.sel = idx;

      // jds: 폴더 선택된 항목 제외
      let menusEl = document.querySelectorAll('.menus .menu');
      if(menusEl) {
        if(menusEl[idx]) {
          menusEl[idx].classList.add('sel');
          let treeEl = document.querySelector('.tree .sel');
          if (treeEl) treeEl.classList.remove('sel');
        }
      }
    },
    deselectAll() {
      const menusEls = this.$refs.menus.querySelectorAll('.menus .sel');
      menusEls.forEach(menusEl => {
        menusEl.classList.remove('sel');
      });
    },
    deselectAllTree() {
      const treeEls = document.querySelectorAll('.tree-list .sel');
      treeEls.forEach(treeEl => {
        treeEl.classList.remove('sel');
      });
    },
    selectByKey(key) {
      this.deselectAll();
      this.deselectAllTree();
      const el = this.$refs.menus.querySelector(`[data-key="${key}"]`);
      if(el) {
        this.selected(el.getAttribute('data-i'))
      }
    },
  },
}
</script>
